import { formatDate } from '@angular/common';
import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCheck, faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { Constants } from 'src/app/common';
import { IUser } from 'src/app/models';
import { IFileCard, IPersonCard } from 'src/app/models/i-person-card';
import { AlertsService } from 'src/app/services/alerts.service';
import { BlockUiHandlerService } from 'src/app/services/block-ui-handler.service';
import { PersonService } from 'src/app/services/person.service';
import { StorageService } from 'src/app/services/storage.service';
import { FilesService } from '../../services/files.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-person-cards',
  templateUrl: './person-cards.component.html',
  styleUrls: ['./person-cards.component.css']
})
export class PersonCardsComponent implements OnInit {

  CurrentPage: number = 1;
  PageSize: number = 8;
  CollectionSize: number = 1;

  ActiveUser: IUser;
  PersonCards: IPersonCard[];
  PersonCardForm: FormGroup;

  modalPersonCardReference: NgbModalRef;

  SearchForm: FormGroup;

  search: boolean;

  // Upload file vars
  modalUploadCardsReference: NgbModalRef;
  UploadFileFrom: FormGroup;
  File: any;
  FileCards: IFileCard[]; 
  FileCardsResult: IFileCard[]; 
  FileInput: any;

  constructor(private modalService: NgbModal,
    private personService: PersonService,
    private storageService: StorageService,
    private blockUiHanddler: BlockUiHandlerService,
    private alertsService: AlertsService,
    private formBuilder: FormBuilder,
    private filesService: FilesService,
    private commonService: CommonService,
    library: FaIconLibrary
  ) {
    library.addIcons(faEdit, faCheck, faTimes)
  }

  ngOnInit(): void {
    this.InitVariables();
    this.ResetForm();
    this.ResetSearchForm();
    this.ResetUploadFileFrom();
    this.LoadPersonCardPagedCount();
  }

  InitVariables(){
    this.FileCards = [];
    this.FileCardsResult = [];
    this.search = false;
    this.PersonCards = [];
    let CurrentUser = this.storageService.GetCurrentSession();
    this.ActiveUser = {
      Id: CurrentUser.Id, 
      Email: CurrentUser.UserName, 
      Password: '', 
      Active: true
    }
  }

  ResetSearchForm(): void {
    let LastMonthDate = new Date();
    LastMonthDate.setMonth(LastMonthDate.getMonth() - 1);
    let MonthDate = formatDate(LastMonthDate, 'yyyy-MM-dd', 'en');
    let NowDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    this.SearchForm = this.formBuilder.group({
      Card: [''],
      User: [''],
      From: [MonthDate, Validators.required],
      To: [NowDate, Validators.required],
      State: [''],
      Active: ['']
    });
  }
  
  LoadPersonCardPagedCount(){
    this.search = false;
    this.blockUiHanddler.Start(1, 'Cargando paginación de cédulas...')
    this.personService.GetPersonCardsCount(
      this.SearchForm.controls['Card'].value,
      this.SearchForm.controls['User'].value,
      this.SearchForm.controls['From'].value,
      this.SearchForm.controls['To'].value,
      this.SearchForm.controls['State'].value,
      this.SearchForm.controls['Active'].value
    ).subscribe(req => {
      this.blockUiHanddler.Stop()
      if(req.Result){
        this.CollectionSize = req.Data;
      this.LoadPersonCards();
      }
    }, err => {
      this.blockUiHanddler.Stop()
      this.alertsService.ShowSmallCornerAlert(err, 2)
    });
  }

  LoadPersonCards(){
    this.blockUiHanddler.Start(1, 'Cargando cédulas...')
    this.personService.GetPersonCardsPaged(
      this.SearchForm.controls['Card'].value,
      this.SearchForm.controls['User'].value,
      this.SearchForm.controls['From'].value,
      this.SearchForm.controls['To'].value,
      this.SearchForm.controls['State'].value,
      this.SearchForm.controls['Active'].value,
      ((this.CurrentPage*this.PageSize)-this.PageSize),
      this.PageSize
    ).subscribe(req => {
      this.blockUiHanddler.Stop()
      if(req.Result){
        this.PersonCards = req.Data;
      }
    }, err => {
      this.blockUiHanddler.Stop()
      this.alertsService.ShowSmallCornerAlert(err, 2)
    });
  }

  RaisePersonCardModal(content): void {
    this.modalPersonCardReference = this.modalService.open(content,
      {
        centered: true,
        backdrop: 'static'
      });
  }

  ResetForm(): void {
    this.PersonCardForm = this.formBuilder.group({
      Id: [-1],
      Card: ['', Validators.required],
      CreateUser: [this.ActiveUser.Email],
      UpdateUser: [this.ActiveUser.Email],
      CreateDate: [''],
      UpdateDate: [''],
      Errors: [''],
      State: [''],
      Active: [true, Validators.required]
    });
  }

  AddPersonCard(content){
    this.ResetForm();
    this.PersonCardForm.controls['Card'].enable();
    this.RaisePersonCardModal(content);
  }

  EditPersonCard(content, PersonCard: IPersonCard){
    this.ResetForm();
    this.PersonCardForm.controls['Card'].disable();
    this.PersonCardForm.controls['Id'].setValue(PersonCard.Id);
    this.PersonCardForm.controls['Card'].setValue(PersonCard.Card);
    this.PersonCardForm.controls['CreateUser'].setValue(PersonCard.CreateUser);
    this.PersonCardForm.controls['Errors'].setValue(PersonCard.Errors);
    this.PersonCardForm.controls['State'].setValue(PersonCard.State);
    this.PersonCardForm.controls['Active'].setValue(PersonCard.Active);
    this.RaisePersonCardModal(content);
  }

  StorePersonCard(){
    this.PersonCardForm.controls['Card'].enable();
    let PersonCard = this.PersonCardForm.value as IPersonCard
    this.PersonCardForm.controls['Card'].disable();
    this.personService.PostPersonCard(PersonCard).subscribe(req => {
      if(req.Result){
        this.ClosePersonCardModal()
        this.LoadPersonCardPagedCount()
        this.alertsService.ShowSmallCornerAlert("Cédula agregada con éxito", 1)
        this.alertsService.ShowBigCenteredAlert("La cédula serán procesadas en breve", 1);
      } else {
        this.alertsService.ShowSmallCornerAlert("La cédula ya está agregada", 3)
      }
    }, err => {
      this.alertsService.ShowSmallCornerAlert(err, 2)
    })
  }

  ClosePersonCardModal(): void {
    this.modalPersonCardReference.close();
  }

  SelectPage(Page: string): void {
    this.CurrentPage = (parseInt(Page, 10) || 1);
  }

  FormatInput(input: HTMLInputElement): void {
    input.value = input.value.replace(Constants.FILTER_PAG_REGEX, '');
  }

  ValidateDate(fieldKey: string){
    this.search = true;
    let NowDate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
    if(!this.SearchForm.controls[fieldKey].value) this.SearchForm.controls[fieldKey].setValue(NowDate);
    if(parseInt(formatDate(this.SearchForm.controls[fieldKey].value, 'yyyy', 'en')) > 9999) this.SearchForm.controls[fieldKey].setValue(NowDate);
  }

  CloseUploadCardsModal(): void {
    this.modalUploadCardsReference.close();
  }

  RaiseUploadCardsModal(content): void {
    if(this.FileCardsResult)
      this.FileCardsResult = []; 
    this.ResetUploadFileFrom();

    this.modalUploadCardsReference = this.modalService.open(content, {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    });
  }

  ResetUploadFileFrom(): void {
    this.UploadFileFrom = this.formBuilder.group({
      File: ['', Validators.required],
      Action: ['CREATE', Validators.required]
    });
  }

  FileSelected(event: any): void {
    this.FileInput = event.target;
    if (event.srcElement.files) {
      let FileExtention: string = event.srcElement.files[0].name.split('.').pop();
      if (FileExtention.toUpperCase() === 'XLS' || FileExtention.toUpperCase() === 'XLSX' || FileExtention.toUpperCase() === 'CSV') {
        this.UploadFileFrom.controls['File'].setValue(event.srcElement.files[0].name);
        this.File = event.srcElement.files[0];
        if(this.File)
          this.UploadFile();
      } else { 
        this.alertsService.ShowBigCenteredAlert(`El archivo ${event.srcElement.files[0].name} debe ser .xls, .xlsx, .csv`, 3);
        this.ResetFile();
      }
    } else {
      this.ResetFile();
    }
  }

  UploadFile(): void {
    const formData = new FormData();
    this.FileCardsResult = [];
    formData.append('file', this.File);
    this.blockUiHanddler.Start(1, 'Subiendo archivo...')
    this.filesService.UploadCardsFile(formData).subscribe(req => {
      this.blockUiHanddler.Stop()
      if(req.Result){
        this.FileCards = req.Data;
      } else {
        this.alertsService.ShowSmallCornerAlert(req.ErrorInfo.Message, 2);
        this.ResetFile();
      }
    }, error => {
      this.blockUiHanddler.Stop()
      this.alertsService.ShowBigCenteredAlert(error, 2)
      this.ResetFile();
    });
  }

  PostCards(): void{
    this.blockUiHanddler.Start(1, 'Realizando acciones...')
    // seteo de acciones
    this.FileCards.forEach(card => card.Action = this.UploadFileFrom.controls['Action'].value);
    this.personService.PostFileCards(this.FileCards).subscribe(req => {
      this.blockUiHanddler.Stop()
      if(req.Result){
        this.alertsService.ShowSmallCornerAlert("Acciones finalizadas con éxito!", 1);
        this.ResetFile();
        this.FileCardsResult = req.Data;
        this.alertsService.ShowBigCenteredAlert("Las cédulas serán procesadas en breve", 1);
        this.LoadPersonCardPagedCount();
      } else {
        this.alertsService.ShowSmallCornerAlert(req.ErrorInfo.Message, 2);
      }
    }, error => {
      this.blockUiHanddler.Stop()
      this.alertsService.ShowBigCenteredAlert(error, 2)
    });
  }

  ResetFile(): void{
    this.ResetUploadFileFrom();
    this.UploadFileFrom.controls['File'].setValue('');
    this.File = null;
    this.FileInput.value = '';
    this.FileCards = [];
  }

  DownloadMassiveTemplateFile(){
    this.blockUiHanddler.Start(1, 'Descargando plantilla...')
    this.filesService.DownloadMassiveTemplateFile().subscribe(response => {
      this.blockUiHanddler.Stop();
      if(response.Result){
        this.commonService.DownloadFile(response.Data.Base64, response.Data.Name, response.Data.Type);
      } else {
        this.alertsService.ShowSmallCornerAlert(response.ErrorInfo.Message, 3);
      }
      
    }, error => {
      this.blockUiHanddler.Stop();;
      this.alertsService.ShowSmallCornerAlert(error, 3);
    })
  }
}
